<template>
  <template v-if="hasPermission">
    <slot />
  </template>
  <template v-else>
    <slot name="fallback" />
  </template>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const currentPermissions = computed(
  () => store.getters['permissions/getPermissions']
);

// TODO: refactor this later
const externalRole = computed(
  () => store.getters['user/externalMemberships/getCurrentProjectRole']
);

const props = defineProps({
  permissions: {
    type: Array,
    default: () => [],
  },
  roles: {
    type: Array,
    default: () => [],
  },
  skipProtect: {
    type: Boolean,
    default: false,
  },
});

const hasPermission = computed(() => {
  if (props.skipProtect) {
    return true;
  }
  if (props.roles) {
    if (props.roles.includes(externalRole.value)) {
      return true;
    }
  }
  if (props.permissions) {
    if (Array.isArray(props.permissions)) {
      return props.permissions.some(permission =>
        currentPermissions.value?.includes?.(permission)
      );
    }
    if (currentPermissions.value) {
      return currentPermissions.value.includes(props.permissions);
    }
  }

  return false;
});
</script>
